var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSlider)?_c('div',{staticClass:"wc-carousel",class:{ 'wc-carousel--snap': _vm.snap }},[_vm._t("default")],2):_c('carousel',{attrs:{"per-page":_vm.perPage}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }